export default "__VITE_ASSET__D3QVXtlB__"